export const NATURE_OF_BUSINESS = [
  "Manufacturer", "Distributor", "Dealer/Reseller", "System Integrator", "OEM",
  "Service Provider", "End Customer", "Academic/Research", "Government/PSU", "Other",
];

export const INDUSTRY_SEGMENT = [
  "Electronics", "Automotive", "Aerospace/Defense", "Industrial Automation",
  "Energy/Utilities", "Healthcare/Medical Devices", "IT/Software",
  "Education/Training", "R&D/Testing", "Other",
];

export const COMPANY_SIZE = ["1–10", "11–50", "51–200", "201–500", "501–1000", "1000+"];

export const PRODUCTS_INTEREST = [
  "Test & Measurement", "Embedded Systems", "IoT/Connectivity", "Power & Energy",
  "Automation", "Software Tools", "Consulting/Training", "Other",
];

export const PURPOSE_OF_VISIT = [
  "Product evaluation", "Pricing info", "Partnership", "Technical discussion",
  "Training/demo", "General exploration",
];

export const PREFERRED_FOLLOWUP = ["Email", "Phone", "WhatsApp", "On-site meeting", "No follow-up needed"];

export const COMMUNICATION_CONSENT = [
  "I agree to receive updates and communications from KevalTek",
  "I do not wish to receive communications",
];

export const BRANDS = [
  "CP PLUS", "PRAMA", "HI-FOCUS", "TRUEVIEW", "HIKVISION", "VOLTAIC CABLE",
  "SEAGATE", "SYROTECH", "SRB", "TRIONET", "LEMORELE", "MAXXION",
  "GRANDSTREAM", "ZKTECO",
];

export const KEVALTEK_LOGO = "/kevaltek-logo.png";
export const NAKODA_LOGO = "/nakoda-logo.png?v=2";
export const CCTV_IMG = "https://images.unsplash.com/photo-1617897711385-df9c86b7dfe3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzN8MHwxfHNlYXJjaHwyfHxjY3R2JTIwc2VjdXJpdHklMjBjYW1lcmElMjBkYXJrJTIwZHJhbWF0aWMlMjBsaWdodGluZ3xlbnwwfHx8fDE3ODQwOTYxNjV8MA&ixlib=rb-4.1.0&q=85";
export const CROWD_IMG = "https://images.unsplash.com/photo-1736425139794-96f1ce1de2a3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTB8MHwxfHNlYXJjaHwzfHxwcm9mZXNzaW9uYWwlMjBjb25mZXJlbmNlJTIwY3Jvd2QlMjBldmVudCUyMGRhcmt8ZW58MHx8fHwxNzg0MDk2MTY1fDA&ixlib=rb-4.1.0&q=85";


// Registration is closed now that the expo has concluded.
export const REGISTRATION_OPEN = false;

// Mysore KevalTek Expo 2026 — event photos
export const EXPO_PHOTOS = [
  {
    url: "https://customer-assets-m6fa6gv7.emergentagent.net/job_kevaltek-expo-form/artifacts/692dvwal_DSC_8517.JPG.webp",
    caption: "Inauguration & ribbon-cutting ceremony",
    span: "lg:col-span-7",
  },
  {
    url: "https://customer-assets-m6fa6gv7.emergentagent.net/job_kevaltek-expo-form/artifacts/tgsgu8s1_DSC_8530.JPG.webp",
    caption: "At the KevalTek Expo backdrop",
    span: "lg:col-span-5",
  },
  {
    url: "https://customer-assets-m6fa6gv7.emergentagent.net/job_kevaltek-expo-form/artifacts/5sblkogd_DSC_8356.JPG.webp",
    caption: "Dignitaries touring the CP PLUS & Prama stalls",
    span: "lg:col-span-5",
  },
  {
    url: "https://customer-assets-m6fa6gv7.emergentagent.net/job_kevaltek-expo-form/artifacts/nfjn7ztm_DSC_8414.JPG.webp",
    caption: "Hi-Focus IntelliSeek smart surveillance booth",
    span: "lg:col-span-7",
  },
  {
    url: "https://customer-assets-m6fa6gv7.emergentagent.net/job_kevaltek-expo-form/artifacts/dvhhgvrb_DSC_8476.JPG.webp",
    caption: "Voltaic Cable — one-stop cabling solutions",
    span: "lg:col-span-12",
  },
];
